import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  WfPropertyListComponent,
  WfPropertyListEntry,
} from 'wflow-main-app/src/app/shared/dumb-components/property-list/property-list.component';
import { PeppolDetail } from '../../../../interfaces/peppol-detail.interface';

@Component({
  selector: 'wf-peppol-detail-sbdh',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule, WfPropertyListComponent],
  templateUrl: './peppol-detail-sbdh.component.html',
  styleUrl: './peppol-detail-sbdh.component.scss',
  host: { class: 'wf-peppol-detail-sbdh' },
})
export class PeppolDetailSbdhComponent {
  readonly detail = input.required<PeppolDetail>();

  protected readonly entries = computed<WfPropertyListEntry[]>(() =>
    this.buildEntries(this.detail()),
  );

  private buildEntries(detail: PeppolDetail): WfPropertyListEntry[] {
    const entries: WfPropertyListEntry[] = [
      { key: 'PEPPOL.Sbdh.SenderId', value: detail.senderId },
      { key: 'PEPPOL.Sbdh.ReceiverId', value: detail.receiverId },
      { key: 'PEPPOL.Sbdh.DocumentIdentifier', value: detail.documentIdentifier },
    ];

    if (detail.documentFormat) {
      entries.push({
        key: 'PEPPOL.Sbdh.DocumentFormat',
        value: detail.documentFormat,
      });
    }
    if (detail.sent) {
      entries.push({
        key: 'PEPPOL.Sbdh.Sent',
        value: detail.sent,
        type: 'datetime',
      });
    }
    if (detail.received) {
      entries.push({
        key: 'PEPPOL.Sbdh.Received',
        value: detail.received,
        type: 'datetime',
      });
    }

    entries.push({
      key: 'PEPPOL.Sbdh.ProcessIdentifier',
      value: detail.processIdentifier,
    });

    return entries;
  }
}
